import { render } from "./BaseTableElement.vue?vue&type=template&id=3bbcc75c&scoped=true&ts=true"
import script from "./BaseTableElement.vue?vue&type=script&lang=ts"
export * from "./BaseTableElement.vue?vue&type=script&lang=ts"

import "./BaseTableElement.vue?vue&type=style&index=0&id=3bbcc75c&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbcc75c"]])

export default __exports__